'use strict';
import isFunction from 'lodash/isFunction';
import isString from 'lodash/isString';
import isUndefined from 'lodash/isUndefined';
import {Observable} from 'rxjs/Observable';
import {SCOPE_DESTROY} from '../../config/constants/view-events';
import {eventToObservable} from '../../core-utilities/rx-utils';
import {observeNewOnScope} from '../../core-utilities/rx-utils';
import template from './personnel-directive.html';
import {getId} from '../../core-utilities/domain/ReduxUtils';

module.exports.directive = [
  PersonnelDirective];

module.exports.controller = [
  '$scope',
  '$attrs',
  '$parse',
  'OrganizationDomain',
  'TeamTypeDomain',
  'PersonnelFilterMixin',
  PersonnelController];

function PersonnelDirective() {
  return {
    restrict: 'E',
    require: ['personnel', '?^^filterContainer'],
    template: template,
    scope: {
      nullable: '=',
      organization: '=',
      selected: '<?',
      filter: '=?',
      showTeams: '=',
      showNonUsers: '=',
      loadingMode: '=',
    },
    controllerAs: 'personnel',
    bindToController: true,
    controller: 'PersonnelController',
    link: function (scope, element, attr, ctrls) {
      var personnelCtrl = ctrls[0];
      var containerCtrl = ctrls[1];
      if (containerCtrl) personnelCtrl.containerCtrl = containerCtrl;
    }
  }
}

function PersonnelController(
  $scope,
  $attrs,
  $parse,
  OrganizationDomain,
  TeamTypeDomain,
  PersonnelFilterMixin,
) {
  const vm = this;
  vm.teams = {};

  vm.onTeamSelect = createHandler('onTeamSelect', '$team');
  vm.onTeamContext = createHandler('onTeamContext', '$team');
  vm.onPersonSelect = createHandler('onPersonSelect', '$person');
  vm.onPersonContext = createHandler('onPersonContext', '$person');

  $scope.$evalAsync(init);

  function init() {
    let filter = null;
    const leave$ = eventToObservable($scope, SCOPE_DESTROY);
    const organization$ = observeNewOnScope($scope, 'personnel.organization.$id')
      .distinctUntilChanged()
      .map(id => id ? vm.organization : null);
    const containerCtrl$ = observeNewOnScope($scope, 'personnel.containerCtrl')
      .filter(containerCtrl => !!containerCtrl)
      .take(1);

    Observable.combineLatest(
      containerCtrl$,
      organization$,
      (containerCtrl, organization) => ({containerCtrl, organization}))
      .takeUntil(leave$)
      .subscribe(withNewOrg);

    function withNewOrg({containerCtrl, organization}) {
      $scope.$evalAsync(() => {
        // cleanup the previous filter, if any
        if (filter) {
          filter.destroyFiltering();
          filter = null;
        }

        if (organization) {
          const orgId = getId(organization);
          OrganizationDomain.$getPersonnelList(orgId).$bindToScope($scope, 'personnelList');

          if (vm.showTeams) {
            vm.teamTypes = OrganizationDomain.$getTeamTypesList(orgId);
          }

          filter = PersonnelFilterMixin($scope, containerCtrl.getFilterScope(), vm);
          filter.initFiltering($scope.personnelList.$toObservable());
        }
      });
    }
  }


  /*****************************************************************************************************************
   * Controller Actions
   ****************************************************************************************************************/

  vm.getTeams = function (teamType) {
    if (teamType) {
      const teamTypeId = getId(teamType);
      vm.teams[teamTypeId] = TeamTypeDomain.$getTeamsList(teamTypeId);
      initializeTeamsWatchers(teamType, vm.teams[teamTypeId]);
      return vm.teams[teamTypeId];
    }
  };

  function createHandler(handlerName, param) {
    var handler;
    if (isString($attrs[handlerName])) {
      handler = $parse($attrs[handlerName]);
    }

    return function eventHandler($event, arg) {
      if (isFunction(handler)) {
        var locals = {$event: $event};
        locals[param] = arg;

        //following the behavior of directives like ng-click, execute the callback in the context of the scope the directive is used in
        handler($scope.$parent, locals);
      }
    }
  }


  /*****************************************************************************************************************
   * Presentation Logic
   ****************************************************************************************************************/

  vm.teamCounts = {};
  vm.teamWatchers = [];
  vm.totalTeams = 0;
  vm.filterable = ($attrs.filterable == 'true');

  function initializeTeamsWatchers(teamType, team) {
    const teamTypeId = getId(teamType);
    if (team && teamType && isUndefined(vm.teamCounts[teamTypeId])) {
      vm.teamCounts[teamTypeId] = Object.keys(team).length;
      const watcher = team.$on('value', function (newValue) {
        vm.teamCounts[teamTypeId] = Object.keys(newValue).length;
        updateTotalTeams();
      });

      vm.teamWatchers.push(function () {
        teamType && team.$off('value', watcher);
      })
    }
  }

  function updateTotalTeams() {
    const keys = Object.keys(vm.teamCounts);
    let total = 0;

    for (let i = 0; i < keys.length; i++) {
      total += vm.teamCounts[keys[i]];
    }

    vm.totalTeams = total;
  }


  /*****************************************************************************************************************
   * Clean up
   ****************************************************************************************************************/

  $scope.$on(SCOPE_DESTROY, cleanup);

  function cleanup() {
    for (let i = 0; i < vm.teamWatchers.length; i++) {
      if (isFunction(vm.teamWatchers[i])) {
        vm.teamWatchers[i]();
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/personnel/directives/PersonnelDirective.js